import React, { useEffect, useState } from 'react';
import { Button, Popover } from 'antd';
import { isTourPublic } from '../../../constants/tourAccessibilityTypes.constants';
import {
  PrivateTourIcon,
  PublicTourIcon,
} from '../TourFullView/components/svg';
import SharingOverview from '../TourFullView/CreateTour/AccesibilityType/SharingOverview';
import userAPI from '../../../API/user.service.api';

const SharingPreview = ({ fullData, type = null }) => {
  const [isVIsible, setVisibility] = useState(false);
  const [friendsData, setFriendsData] = useState([]);
  const [bikeClubsData, setBikeClubsData] = useState([]);
  const [bikerBedsData, setBikerBedsData] = useState([]);
  const [bikeClubsChecked, setBikeClubsChecked] = useState([]);
  const [bikerBedsChecked, setBikerBedsChecked] = useState([]);
  const currentUserId = fullData.data.owner.id || fullData.data.owner;
  const tourType = !type ? fullData.data.type : fullData.data.access;
  const checkedFriends = fullData.data.listCheckedFriends || [];
  const listCheckedClubs = fullData.data.listCheckedClubs || [];

  useEffect(() => {
    userAPI
      .getBikerBedsById(currentUserId)
      .then((res) => {
        const { code, entities } = res;
        if (code === 200) {
          setBikerBedsData([...entities]);
          const checkedClubs = entities
            .filter(({ id }) => listCheckedClubs.includes(id))
            .map(({ id }) => id);
          setBikerBedsChecked(checkedClubs);
        } else {
          console.info(res);
        }
      })
      .catch((err) => console.log(err));

    userAPI
      .getClubsById(currentUserId)
      .then((res) => {
        const { code, clubs } = res;
        if (code === 200) {
          setBikeClubsData([...clubs]);
          const checkedClubs = clubs
            .filter(({ id }) => listCheckedClubs.includes(id))
            .map(({ id }) => id);
          setBikeClubsChecked(checkedClubs);
        } else {
          console.info(res);
        }
      })
      .catch((err) => {
        console.log(err);
      });

    userAPI
      .getFriendsById(currentUserId)
      .then((res) => {
        const { code, friends } = res;
        if (code === 200) {
          setFriendsData(friends);
        } else {
          console.info(res);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [currentUserId, tourType]);

  const showModal = () => {
    setVisibility(true);
  };

  const iconStyle = {};
  if (isVIsible) {
    iconStyle.fill = '#aa2493';
  }

  const getIcon = (type) =>
    isTourPublic(type) ? (
      <PublicTourIcon width={18} height={18} />
    ) : (
      <PrivateTourIcon width={18} height={18} />
    );

  const getNameById = {
    bikeClub: (value) =>
      bikeClubsData.filter(({ id }) => id === value)[0]?.title,
    bikeClubs: (values) => values.map((value) => getNameById.bikeClub(value)),
    bikerBed: (value) =>
      bikerBedsData.filter(({ id }) => id === value)[0]?.title,
    bikerBeds: (values) => values.map((value) => getNameById.bikerBed(value)),
    friend: (value) => friendsData.filter(({ id }) => id === value)[0]?.name,
    friends: (values) => values.map((value) => getNameById.friend(value)),
  };

  const content = (
    <SharingOverview
      accessType={tourType}
      friends={getNameById.friends(checkedFriends)}
      bikeClubs={getNameById.bikeClubs(bikeClubsChecked)}
      bikerBeds={getNameById.bikerBeds(bikerBedsChecked)}
    />
  );

  return (
    <>
      <Popover content={content}>
        <Button
          size="large"
          className="preview-tour-buttons changeFolder sharing"
          onClick={showModal}
          style={iconStyle}
        >
          {getIcon(tourType)}
        </Button>
      </Popover>
    </>
  );
};

export default SharingPreview;
